// Breadcrumb strip for the active category, built from category.path[] — no
// recursive lookups (#63 AC5). Each crumb is clickable to jump up the tree.
import React from 'react';
import type { Category } from '../shared/types';
import { breadcrumbFor } from '../services/category-nav';

const CategoryBreadcrumb: React.FC<{
  categories: Category[];
  selectedId: string;
  onSelect: (id: string) => void;
}> = ({ categories, selectedId, onSelect }) => {
  const crumbs = breadcrumbFor(categories, selectedId);
  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Kategorie-Pfad" className="flex flex-wrap items-center gap-1 text-sm font-bold text-slate-500">
      {crumbs.map((c, i) => (
        <span key={c.id} className="flex items-center gap-1">
          {i > 0 && <span className="text-slate-300 dark:text-slate-600">›</span>}
          <button
            onClick={() => onSelect(c.id)}
            className={`px-1 rounded hover:text-emerald-500 transition-colors ${i === crumbs.length - 1 ? 'text-slate-900 dark:text-white' : ''}`}
          >
            {c.name}
          </button>
        </span>
      ))}
    </nav>
  );
};

export default CategoryBreadcrumb;
